import { render, staticRenderFns } from "./CompanyRating.vue?vue&type=template&id=1d24546e&"
import script from "./CompanyRating.vue?vue&type=script&lang=js&"
export * from "./CompanyRating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports